import { getPlatformLogoPath } from "src/app/common/platformUtils";
import { IntegrationModel } from "src/app/models/api";
import { AutocompleteSearchResultsModel } from "src/app/models/api/autocompleteSearchResults.model";
import { PolicyMinimalModel } from "src/app/models/api/governance/policy.model";
import { BaseViolationRule } from "src/app/models/api/governance/violationRule.model";
import { ISelectOption } from "src/app/models/selectOptions";
import { FilterTypesEnum } from "../../filterTypes.enum";
import { LabelModel } from "src/app/models/api/common";
import { FeatureFlagsService } from "src/app/services/infra/featureFlags/feature-flags.service";
import { ResourceType } from "src/app/models/api/common";
import { FeatureFlagTypes } from "src/app/models/featureFlag/featureFalgsTypes.enum";

export const fromPolicyMinimalToSelectOption = (policy: PolicyMinimalModel, integrationNamesById: { [id: string]: string }) =>
    ({
        id: policy.id,
        value: policy.id,
        displayName: `${policy.name} (${integrationNamesById[policy.integrationId]})`,
        filterType: FilterTypesEnum.Policy,
        categoryName: FilterTypesEnum.Policy,
        withoutBeautifyDisplayName: true,
        iconPath: getPlatformLogoPath(policy.platform),
    }) as ISelectOption;

export const fromIntegrationToSelectOption = (integration: IntegrationModel) =>
    ({
        id: integration.id,
        value: integration.id,
        displayName: integration.name,
        filterType: FilterTypesEnum.Integration,
        categoryName: FilterTypesEnum.Integration,
        withoutBeautifyDisplayName: true,
        iconPath: getPlatformLogoPath(integration.platform),
    }) as ISelectOption;

export const fromAutocompleteSearchResultToSelectOption = (result: AutocompleteSearchResultsModel, filterType: FilterTypesEnum) =>
    ({
        id: result.id,
        value: result.id,
        displayName: result.displayName,
        filterType: filterType,
        categoryName: filterType,
        withoutBeautifyDisplayName: true,
    }) as ISelectOption;

export const fromViolationRuleToSelectOption = (rule: BaseViolationRule) =>
    ({
        id: rule.id,
        value: rule.id,
        displayName: rule.id,
        filterType: FilterTypesEnum.ViolationRule,
        categoryName: FilterTypesEnum.ViolationRule,
        withoutBeautifyDisplayName: true,
    }) as ISelectOption;

export const fromLabelToSelectOption = (label: LabelModel) =>
    ({
        id: label.id,
        value: label.id,
        displayName: label.displayName,
        filterType: FilterTypesEnum.Label,
        categoryName: FilterTypesEnum.Label,
        withoutBeautifyDisplayName: true,
    }) as ISelectOption;

export const removeUnusedFilterByFeatureFlag = (
    resourceTypeSelectOptions: ISelectOption[],
    featureFlagsService: FeatureFlagsService,
): ISelectOption[] => {
    let returnedResourceTypeSelectOptions: ISelectOption[] = resourceTypeSelectOptions;

    if (!featureFlagsService.isFeatureEnabled(FeatureFlagTypes.AiExtensions)) {
        returnedResourceTypeSelectOptions = returnedResourceTypeSelectOptions.filter(
            (option) =>
                option.value !== ResourceType.conversational_plugin &&
                option.value !== ResourceType.connection_plugin &&
                option.value !== ResourceType.flow_plugin &&
                option.value !== ResourceType.graph_connection,
        );
    }

    return returnedResourceTypeSelectOptions;
};

export const checkAllGivenIdsExistInOptions = (options: ISelectOption[], ids: string[]): boolean =>
    options
        .takeIf((options) => options.length > 0)
        ?.toSetBy((option) => option.id)
        ?.let((idSet) => ids.every((id) => idSet.has(id))) ?? false;
